import { get } from '@core/api/baseApi';
import { BranchModel } from '@core/types';

const getBranches = async (): Promise<BranchModel[]> => await get('/branches');

export default getBranches;
